import { render, staticRenderFns } from "./AvatarButton.vue?vue&type=template&id=794d6c04&scoped=true&"
import script from "./AvatarButton.vue?vue&type=script&lang=js&"
export * from "./AvatarButton.vue?vue&type=script&lang=js&"
import style0 from "./AvatarButton.vue?vue&type=style&index=0&id=794d6c04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794d6c04",
  null
  
)

export default component.exports